import { createContext, useContext, useEffect, useState } from "react";
import { DEFAULT_SITE, getSiteSettings, mergeSite } from "@/lib/site";
import { waConfig } from "@/lib/whatsapp";

const SiteContext = createContext(DEFAULT_SITE);

export const SiteProvider = ({ children }) => {
  const [site, setSite] = useState(DEFAULT_SITE);

  useEffect(() => {
    getSiteSettings()
      .then((saved) => {
        const merged = mergeSite(saved);
        waConfig.number = merged.whatsapp;
        setSite(merged);
      })
      .catch(() => {});
  }, []);

  return <SiteContext.Provider value={site}>{children}</SiteContext.Provider>;
};

export const useSite = () => useContext(SiteContext);
